import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../../../reduxStore/store"

interface SidebarNavState {
  openItems: string[]
}

const initialState: SidebarNavState = {
  openItems: [],
}

const sidebarNavSlice = createSlice({
  name: "sidebarNav",
  initialState,
  reducers: {
    toggleItem(state, action: PayloadAction<string>) {
      const index = state.openItems.indexOf(action.payload)

      if (index >= 0) {
        state.openItems.splice(index, 1)
      } else {
        state.openItems.push(action.payload)
      }
    },
  },
})

export const selectOpenItems = (state: RootState) => {
  return state?.sidebarNav.openItems
}

export const { toggleItem } = sidebarNavSlice.actions

export default sidebarNavSlice.reducer
